import { axiosDelete, axiosGet, axiosPost, axiosPut } from '../axios/httpRequest';

/**
 * 菜单列表
 */
export const getMenuListApi = params => {
    return axiosGet('api/menu/v1/menu', params);
};

/**
 * 新增菜单
 */
export const postAddMenuApi = params => {
    return axiosPost('api/menu/v1/menu', params);
};

/**
 * 获取登录账号菜单
 */
export const getCurrentMenuApi = params => {
    return axiosGet('api/menu/v1/menu/current/admin', params);
};

/**
 * 获取角色菜单
 */
export const getRoleMenuApi = params => {
    return axiosGet(`api/menu/v1/menu/role/${params.role_id}/menu`, params);
};

/**
 * 为角色配置菜单
 */
export const putRoleMenuApi = params => {
    return axiosPut(`api/menu/v1/menu/${params.menuId}/role/${params.roleId}`, params);
};

/**
 * 为角色配置菜单
 */
export const delRoleMenuApi = params => {
    return axiosDelete(`api/menu/v1/menu/${params.menu_id}/role/${params.role_id}`, params);
};

/**
 * 获取菜单权限
 */
export const getMenuApisApi = params => {
    return axiosGet(`api/menu/v1/menu/${params.menu_id}/auth`, params);
};

/**
 * 添加菜单权限
 */
export const putMenuApisApi = params => {
    return axiosPut(`api/menu/v1/menu/${params.menuId}/auth/${params.authId}`, params);
};

/**
 * 删除菜单权限
 */
export const delMenuApisApi = params => {
    return axiosDelete(`api/menu/v1/menu/${params.menu_id}/auth/${params.auth_id}`, params);
};
